import { el } from './layout';

export function statusBadge(status: string): HTMLElement {
  const key = String(status || 'queued').toLowerCase();
  const cls = [
    'queued',
    'running',
    'needs_review',
    'approved',
    'exported',
    'error',
  ].includes(key)
    ? key
    : 'queued';
  return el('span', {
    className: `badge badge-${cls}`,
    text: key,
  });
}

export function tierBadge(tier: string | null | undefined): HTMLElement {
  const t = String(tier || '-').toUpperCase();
  const cls = t === 'A' || t === 'B' || t === 'C' ? t.toLowerCase() : 'c';
  return el('span', {
    className: `badge badge-tier-${cls}`,
    text: t,
  });
}
